import React from "react";
import { Table } from "semantic-ui-react";

class Footer extends React.Component {
  state = {};
  render() {
    return (
      <Table className={"app-footer table-no-border"}>
        <Table.Body>
          <Table.Row>
            <Table.Cell width={2} className="font-family">
              LocatePLUS © {new Date().getFullYear()}
            </Table.Cell>

            <Table.Cell width={2}>
              <a
                href="https://lp-training-videos.s3.us-east-1.amazonaws.com/LocatePLUS+Complete+User+Guide.pdf"
                className="font-family"
                alt="Link to User Guide pdf which opens in a new tab"
                target="_blank"
                rel="noopener noreferrer"
              >
                User Guide
              </a>
            </Table.Cell>

            <Table.Cell width={2}>
              <a
                href="https://locateplus.com/wp-content/uploads/2026/07/LocatePLUS-Terms-of-Use.pdf"
                className="font-family"
                alt="Link to the Terms and conditions pdf which opens in a new tab"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Use
              </a>
            </Table.Cell>

            <Table.Cell width={2}>
              <a
                href="https://www.locateplus.com/privacy-policy"
                className="font-family"
                alt="Link to the privacy policy pdf which opens in a new tab"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </Table.Cell>

            <Table.Cell width={2}>
              <a
                href="https://locateplus.com/contact-us-2016/contact-customer-service/"
                className="font-family"
                alt="Link to the contact us page which opens in a new tab"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact US
              </a>
            </Table.Cell>

            <Table.Cell width={2}>
              <a
                href="https://locateplus.com/contact-us-2016/contact-customer-service/"
                className="font-family"
                alt="Link to the contact us page which opens in a new tab"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support
              </a>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/navigation/Footer.js